/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Terminated_AtInputs */

const cs_field_terminated_at = /** @type {(inputs: Field_Terminated_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukončeno dne`)
};

const en_field_terminated_at = /** @type {(inputs: Field_Terminated_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminated at`)
};

/**
* | output |
* | --- |
* | "Terminated at" |
*
* @param {Field_Terminated_AtInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_terminated_at = /** @type {((inputs?: Field_Terminated_AtInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Terminated_AtInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_terminated_at(inputs)
	return cs_field_terminated_at(inputs)
});